@if (canRead()) {
  <h3 class="mt-4">Bills</h3>
  @if (loading()) {
    <div data-testId="bills-table-loading" class="flex justify-content-center align-items-center p-4">
      <fa-icon [icon]="['far', 'spinner']" spin size="2x" class="text-primary" />
      <span class="ml-3 text-lg">Loading bills...</span>
    </div>
  } @else {
    <p-table
      data-testId="bills-table"
      [value]="bills()"
      styleClass="p-datatable-lg p-datatable-striped">
      <ng-template #header>
        <tr>
          <th>Bill Number</th>
          <th>Year</th>
          <th>Type</th>
          <th>Status</th>
          <th class="text-right">Total</th>
          <th>Issued</th>
        </tr>
      </ng-template>
      <ng-template #body let-bill>
        <tr
          data-testId="bills-table-row"
          class="cursor-pointer"
          (click)="viewBill(bill)"
          pTooltip="Click to open invoice"
          tooltipPosition="top">
          <td data-testId="bills-table-number">{{ bill.completeBillNumber }}</td>
          <td>{{ bill.billingYear }}</td>
          <td>{{ formatBillType(bill.billType) }}</td>
          <td>
            <p-tag [value]="bill.status" [severity]="statusSeverity(bill.status)" />
          </td>
          <td class="text-right">
            {{ bill.totalAmount | currency: 'EUR' : 'symbol' : '1.2-2' }}
          </td>
          <td>{{ (bill.issuedAt | date: 'mediumDate' : 'UTC') || '—' }}</td>
        </tr>
      </ng-template>
      <ng-template #emptymessage>
        <tr>
          <td colspan="6" class="text-center p-4">
            <div class="flex flex-column align-items-center gap-3">
              @if (hasError()) {
                <fa-icon [icon]="['far', 'triangle-exclamation']" class="text-red-400" size="2x" />
                <p class="text-gray-600 m-0 font-medium">Failed to load bills</p>
              } @else {
                <fa-icon [icon]="['far', 'folder-open']" class="text-gray-400" size="2x" />
                <p class="text-gray-600 m-0 font-medium">No Bills found</p>
                <p class="text-gray-400 m-0 text-sm">No active invoices reference this entity.</p>
              }
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
}
